import config from '../../configuration';

let OpenGraph = function() {
	const tags = {
		title: v => config.baseTitle + ' - ' +
			(v.title || v.name || config.defaultTitle),
		description: v => v.description || config.defaultDescription,
		image: v => v.image || config.defaultImage
	};
	const nodes = {};
	
	Object.keys(tags).forEach(tag => {
		let node = document.createElement('meta');
		node.setAttribute('property', 'og:' + tag);
		node.content = '';
		nodes[tag] = node;
		document.head.appendChild(node);
	});

	this.set = function(values) {
		Object.entries(tags).forEach(([tag, extract_from]) => {
			nodes[tag].content = extract_from(values);
		});
		document.title = nodes.title.content;
	};
};

const graph = new OpenGraph();

export default graph;
